import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import { TYPEOF } from '../../constants';
import { TooltipTypes } from '../../utils/tooltipConstants';

var formatter = require('format-number');

var format = formatter({
  prefix: '',
  suffix: '',
  truncate: 1
});

var CurrencyDisplay = /*#__PURE__*/function (_Component) {
  _inherits(CurrencyDisplay, _Component);

  var _super = _createSuper(CurrencyDisplay);

  function CurrencyDisplay() {
    var _this;

    _classCallCheck(this, CurrencyDisplay);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {};

    _this._truncateValue = function (value) {
      var truncationTypes = [{
        value: 0,
        postfix: ''
      }, {
        value: 1000000,
        postfix: 'M'
      }, {
        value: 1000000000,
        postfix: 'B'
      }, {
        value: 1000000000000,
        postfix: 'T'
      }];
      var rval = null;
      truncationTypes.forEach(function (truncationType) {
        if (value >= truncationType.value) {
          rval = truncationType;
        }
      });
      return rval;
    };

    _this._formatValue = function (value) {
      var truncate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (truncate) {
        var truncation = _this._truncateValue(value);

        if (truncation.value > 0) {
          return format(value / truncation.value) + truncation.postfix;
        }

        return format(value);
      }

      return format(value);
    };

    _this._showTooltipMobile = function (type) {
      if (_this.props.tooltipType !== TooltipTypes.COINS || _this.props.tooltipType !== TooltipTypes.LOYALTY) {
        var _tooltipDetails = {
          disableChildren: true,
          title: _this.rawValue,
          source: _this.props.source,
          ibw: _this.props.ibw,
          iconType: _this.props.iconType,
          containerStyle: _objectSpread({
            width: _this.props.containerWidth,
            height: _this.props.containerHeight
          }, _this.props.tooltipPosition),
          tipStyle: _objectSpread({}, _this.props.tipStyle ? _this.props.tipStyle : {}),
          actionHandler: _this.props.onClick
        };

        _this.props.changeTooltipType(type);

        _this.props.tooltipDetails(_tooltipDetails);

        _this.props.shouldShowTooltip(true);
      } else {
        _this.props.changeTooltipType();

        _this.props.shouldShowTooltip(false);
      }
    };

    return _this;
  }

  _createClass(CurrencyDisplay, [{
    key: "render",
    value: function render() {
      var displayText = this.props.value;
      this.rawValue = null;

      if (typeof this.props.value === TYPEOF.NUMBER) {
        displayText = this._formatValue(this.props.value);
        this.rawValue = this._formatValue(this.props.value, false);
      }

      var truncated = this.props.value >= 1000000;
      return this.props.render({
        displayText: displayText,
        truncated: truncated,
        rawValue: this.rawValue,
        containerWidth: this.props.containerWidth,
        containerHeight: this.props.containerHeight,
        onClickHandler: this.props.imageOnly || truncated ? this.props.toggleTooltip || this._showTooltipMobile : this.props.enableOnClick ? this.props.onClick : null
      });
    }
  }]);

  return CurrencyDisplay;
}(Component);

export { CurrencyDisplay as default };
CurrencyDisplay.defaultProps = {
  containerWidth: 200,
  containerHeight: 60
};